export const radii = {
  md: '10px',
  lg: '20px',
  round: '50%',
}
